const baseUrls = {
  docNetGatewayStaticApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/static/api`,
  docNetGatewayUsersApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/users/api`,
  docNetGatewayProfilesApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/profile/api`,
  docNetGatewayContentUploaderApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/content-uploader/api`,
  docNetGatewayFeedApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/feed/api`,
  docNetGatewayCircleApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/circle/api`,
  docNetGatewayRssFeedApiBaseUrl: `${process.env.REACT_APP_DOC_NET_API_GATEWAY_BASE_URL}/rss/api`,
};

const urls = {
  commonUrls: {
    getStaticData: `${baseUrls.docNetGatewayStaticApiBaseUrl}/generic/dropdowns`,
    getCompanyProfiles: `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/companyprofile`,
    getPreSignedUrl: `${baseUrls.docNetGatewayContentUploaderApiBaseUrl}/presignedurl/upload`,
    readPreSignedUrl: `${baseUrls.docNetGatewayContentUploaderApiBaseUrl}/presignedurl/read`,
  },
  generalUrls: {},
  postsUrls: {
    addPost(profileKey) {
      return `${baseUrls.docNetGatewayFeedApiBaseUrl}/feed/${profileKey}/posts`;
    },
    getPosts(profileKey) {
      return `${baseUrls.docNetGatewayFeedApiBaseUrl}/feed/${profileKey}/posts`;
    },
    deletePost(postKey) {
      return `${baseUrls.docNetGatewayFeedApiBaseUrl}/post/${postKey}`;
    },
    addRssChannel: `${baseUrls.docNetGatewayRssFeedApiBaseUrl}/feed`,
    editRssChannel: `${baseUrls.docNetGatewayRssFeedApiBaseUrl}/feed`,
    getRssChannels: `${baseUrls.docNetGatewayRssFeedApiBaseUrl}/feed`,
  },
  doctorsUrls: {
    getDoctorProfiles: `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/userprofile`,
    getDoctorUserInfo: `${baseUrls.docNetGatewayUsersApiBaseUrl}/users`,
    updateDoctorLicenceStatus(profileKey) {
      return `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/userprofile/${profileKey}/licence`;
    },
    getDoctorBadges(profileKey) {
      return `${baseUrls.docNetGatewayProfilesApiBaseUrl}/userprofile/${profileKey}/badge`;
    },
    assignOrRevokeDoctorBadges(profileKey) {
      return `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/${profileKey}/badge`;
    },
  },
  companyActivationUrls: {
    updateCompanyLicenceStatus(companyProfileKey) {
      return `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/companyprofile/${companyProfileKey}/licence`;
    },
  },
  circlesUrls: {
    getPendingClosedCircles: `${baseUrls.docNetGatewayCircleApiBaseUrl}/admin/circle`,
    changeClosedCircleStatus(circleKey) {
      return `${baseUrls.docNetGatewayCircleApiBaseUrl}/admin/circle/${circleKey}/status`;
    },
  },
  companiesUrls: {
    addCompany: `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/companyprofile`,
  },
  profilesUrls: {
    getCompanyProfile: `${baseUrls.docNetGatewayProfilesApiBaseUrl}/companyprofile`,
    updateProfileData: `${baseUrls.docNetGatewayProfilesApiBaseUrl}/admin/companyprofile`,
  },
  accountManagementUrls: {
    getApiAuthToken: `${baseUrls.docNetGatewayUsersApiBaseUrl}/logins/externallogin`,
  },
};

export default urls;
